// extracted by mini-css-extract-plugin
module.exports = {"root":"PpcSpeakingSession-module--root--2chBb","list":"PpcSpeakingSession-module--list--cinqN","listItemWrapper":"PpcSpeakingSession-module--listItemWrapper--2ze3d"};